<template>
  <div class="step-wrapper">
    <div class="step-wrapper-subject">
      <strong>step 3 | choose your letter height</strong>
    </div>

    <div class="step-wrapper-description mt-4">
    When choosing the letter height, note that the measurement below is of capital letters. Changing the size of the letters will the overall dimensions of the text. It is accurately represented in the box to the right.
    </div>

    <b-form-select v-model="height" :options="options" class="mt-4" />

    <b-button variant="default" class="mt-4 go-next" v-on:click="goNext">
      Next
    </b-button>
  </div>
</template>

<script>
  import { STENCILCONST } from '../modules/constant.js.erb'

  export default {
    computed: {
      options: function () {
        return this.availableHeights.filter(height => parseFloat(height.value) > this.greaterThan);
      },
      currentFont() {
        return this.$store.state.product.textFont;
      },
      currentFontData: function() {
        return this.$store.state.product.fonts.find(f => f.id == this.currentFont) || {};
      },
      greaterThan: function() {
        if(this.currentFontData.restrictions && this.currentFontData.restrictions.gt) {
          return this.currentFontData.restrictions.gt;
        } else {
          return 0;
        }
      },
      availableHeights: function() {
        return this.$store.state.product.font_sizes;
      },
      height: {
        get: function() {
          return this.$store.state.product.textHeight;
        },
        set: function(height) {
          this.$store.dispatch('product/SET_HEIGHT', height);
        }
      }
    },
    methods: {
      goNext(evt) {
        this.$store.dispatch('product/SET_OLDTAB', 2)
        this.$store.dispatch('product/SET_ACTIVETAB', 2)
        this.$store.dispatch('product/SET_ACTIVETAB', 3)
      }
    }
  }
</script>
